import React from 'react';
import { useSelector } from 'react-redux';
import { Box } from '@mui/material';
import AdminMenus from '../AdminMenus';
import WelcomeMenus from '../../WelcomeMenus';
import HiringPartnerList from './HiringPartnerList';

const AllHiringPartners = () => {
  const { isAuthenticated, user } = useSelector((s) => s.auth);
  const userId = user?.role_id;

  if (!isAuthenticated) return <WelcomeMenus />;

  return (
    <div className="container-xxl">
      {userId === 1 ? (
        <div className="container">
          <div className="mb-3">
            <AdminMenus buttonName="Add Hiring Partner" pageName="addHiringPartner" />
          </div>
          <Box sx={{ width: '100%' }}>
            <HiringPartnerList />
          </Box>
        </div>
      ) : (
        <WelcomeMenus />
      )}
    </div>
  );
};

export default AllHiringPartners;
